import styled from 'styled-components';
import { Card as AntdCard, Radio as AntdRadio, Button, Typography, Col, Slider } from 'antd';

const { Text, Title } = Typography;

export const StyledCard = styled(AntdCard)`
	margin-bottom: 16px;
	padding: 16px;
	border-radius: 24px;
	width: 70%;

	@media (max-width: 1600px) {
		width: 100%;
	}

	@media (max-width: 768px) {
		padding-left: 15px;
		padding-right: 15px;

		.ant-card-body {
			padding: 0 !important;
		}
	}
`;

export const TitleContainer = styled.div`
	margin-bottom: 8px;
`;

export const StyledTitle = styled(Title)`
	margin-bottom: 1rem;
`;

export const StyledText = styled(Text)`
	font-size: 16px;

	@media (max-width: 768px) {
		font-size: 14px;
	}
`;

export const StrongText = styled(Text).attrs({ strong: true })``;

export const ComparisonContainer = styled.div`
	display: flex;
	margin-top: 24px;

	@media (max-width: 768px) {
		display: block;
	}
`;

export const ColumnContainer = styled.div`
	flex: 1;
`;

export const LeftColumn = styled(ColumnContainer)`
	padding-right: 12px;
	border-right: 2px solid rgba(217, 217, 217, 1);

	@media (max-width: 768px) {
		padding-right: 0;
		border-right: none;
	}
`;

export const RightColumn = styled(ColumnContainer)`
	padding-left: 12px;

	@media (max-width: 768px) {
		padding-left: 0;
	}
`;

export const PairContainer = styled.div`
	margin-bottom: 10px;
	margin-top: 10px;
	justify-content: center;
	display: flex;
`;

export const OptionRow = styled.div`
	display: flex;
	margin-bottom: 0px;
	align-items: center;
`;

export const LeftOption = styled.div`
	width: 40%;
	text-align: right;
	padding-right: 8px;
`;

export const MiddleOption = styled.div`
	width: 20%;
	text-align: center;
`;

export const RightOption = styled.div`
	width: 40%;
	text-align: left;
	padding-left: 8px;
`;

export const RadioContainer = styled.div`
	text-align: center;
	margin-bottom: 32px;
`;

export const LeftRadio = styled(AntdRadio)`
	margin-right: 24px;
`;

export const RightRadio = styled(AntdRadio)``;

export const SubmitButton = styled.button`
	background-color: rgba(0, 47, 187, 1);
	color: white;
	border: none;
	border-radius: 4px;
	padding: 8px 16px;
	font-size: 16px;
	cursor: pointer;

	&:disabled {
		background-color: rgba(255, 255, 255, 0.5);
		color: rgba(0, 0, 0, 0.5);
		cursor: not-allowed;
	}
`;

export const SaveButton = styled.button`
	background-color: #fff;
	color: rgba(38, 38, 38, 1);
	border: 1px solid rgba(230, 230, 230, 1);
	border-radius: 4px;
	padding: 8px 16px;
	font-size: 16px;
	cursor: pointer;
`;

export const SliderContainer = styled.div`
	margin-top: 20px;
	margin-bottom: 10px;
	padding: 0;

	@media (max-width: 768px) {
		margin-top: 0;
		margin-bottom: 0;
		padding: 0;
	}
`;

export const SliderLabels = styled.div`
	display: flex;
	justify-content: space-between;
	margin-top: 5px;
`;

export const SliderLabel = styled.span`
	font-weight: 700;
	font-size: 15px;
	color: rgba(0, 0, 0, 0.65);
`;

export const OptionBox = styled.div<{ isSelected?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.3s;
	width: 13rem;
	min-height: 2.5rem;
	border-radius: 4px;
	border: 1px solid ${(props) => (props.isSelected ? '#e6eaf8' : '#e6e6e6')};
	background-color: ${(props) => (props.isSelected ? '#e6eaf8' : '#ffffff')};
	padding: 0.5rem 1rem;
	cursor: pointer;
	text-align: center;

	&:hover {
		color: #2f54eb;
		border-color: #2f54eb;
	}

	@media (max-width: 1150px) {
		width: 11rem;
	}

	@media (max-width: 768px) {
		min-width: 8rem;
		padding: 0;
		width: auto;
	}
`;

export const OptionText = styled.span<{ isSelected?: boolean }>`
	font-size: 1rem;
	font-weight: ${(props) => (props.isSelected ? '500' : '400')};
	line-height: 1.5rem;
	letter-spacing: -0.5%;
	color: ${(props) => (props.isSelected ? '#002fbb' : '#262626')};
	white-space: normal;
	overflow: hidden;
	text-overflow: ellipsis;

	@media (max-width: 768px) {
		font-size: 14px;
		text-wrap: nowrap;
	}
`;

export const RadioOptionContainer = styled.div`
	flex: 1;
	margin: 0 5px;
	position: relative;
	width: 100%;

	@media (max-width: 768px) {
		margin: 0 0px;
	}
`;

export const MiddleOptionText = styled.div`
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 12px;
	font-size: 16px;
	color: rgba(38, 38, 38, 1);
	span {
		font-weight: 700;
	}

	@media (max-width: 768px) {
		font-size: 14px;
		padding: 0 8px;
	}
`;

export const RadioOptionsContainer = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-between;
	margin-top: 16px;
	flex-wrap: wrap;
	row-gap: 16px;

	span.ant-radio + * {
		font-size: 18px;
	}

	@media (max-width: 768px) {
		justify-content: flex-start;
		justify-content: inherit;
		display: grid;
		row-gap: 10px;
	}
`;

export const RadioOptionItem = styled.div`
	text-align: center;

	@media (max-width: 768px) {
		text-align: left;
	}
`;

export const PaginationContainer = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 24px;
	margin-bottom: 16px;

	.ant-pagination-item {
		border-color: #002fbb;

		&-active {
			background-color: #002fbb;
			a {
				color: white;
			}
		}
	}

	.ant-pagination-prev,
	.ant-pagination-next {
		button {
			&:hover {
				border-color: #002fbb;
				color: #002fbb;
			}
		}
	}
`;

export const SurveyPaginationControls = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-top: 24px;
`;

export const MobilePaginationControls = styled.div`
	display: flex;
	justify-content: space-between;
	margin-top: 24px;
	margin-bottom: 16px;
	width: 100%;
`;

export const PaginationButton = styled.button<{ isPrimary?: boolean }>`
	background-color: ${(props) => (props.isPrimary ? 'rgba(0, 47, 187, 1)' : 'white')};
	color: ${(props) => (props.isPrimary ? 'white' : '#595959')};
	border: ${(props) => (props.isPrimary ? 'none' : '1px solid #d9d9d9')};
	border-radius: 4px;
	padding: 8px 16px;
	font-size: 14px;
	cursor: pointer;
	display: flex;
	align-items: center;
	gap: 8px;

	&:hover {
		background-color: ${(props) => (props.isPrimary ? 'rgba(0, 47, 187, 0.8)' : '#f5f5f5')};
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;

export const ProgressIndicator = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 24px;
	font-size: 14px;
	color: #8c8c8c;
`;

export const QuestionsContainer = styled.div`
	min-height: 100px;

	@media (max-width: 768px) {
		min-height: 100px;
	}
`;

export const NumericPaginationContainer = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 24px;
	margin-bottom: 16px;
	gap: 8px;
`;

export const PaginationItem = styled.div<{ isActive?: boolean }>`
	width: 40px;
	height: 40px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: ${(props) => (props.isActive ? '#eef0ff' : '#f5f5f5')};
	color: ${(props) => (props.isActive ? '#1946e8' : '#8c8c8c')};
	border-radius: 4px;
	font-size: 16px;
	font-weight: ${(props) => (props.isActive ? '500' : 'normal')};
	cursor: pointer;

	&:hover {
		background-color: ${(props) => (props.isActive ? '#eef0ff' : '#e6e6e6')};
	}
`;

export const PaginationArrow = styled.div<{ disabled?: boolean }>`
	width: 40px;
	height: 40px;
	display: flex;
	justify-content: center;
	align-items: center;
	color: ${(props) => (props.disabled ? '#d9d9d9' : '#8c8c8c')};
	border-radius: 4px;
	font-size: 16px;
	cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};

	&:hover {
		background-color: ${(props) => (props.disabled ? '#f5f5f5' : '#e6e6e6')};
	}
`;

export const MobileButtonsContainer = styled.div`
	display: flex;
	justify-content: space-between;
	margin-top: 24px;
	margin-bottom: 16px;

	@media (min-width: 769px) {
		display: none;
	}
`;

export const DesktopPaginationContainer = styled.div`
	@media (max-width: 768px) {
		display: none;
	}
`;

export const StyledProgressContainer = styled.div`
	margin-top: 2rem;
	margin-bottom: 1rem;

	span {
		font-size: 14px;
		font-weight: 600;
	}

	.ant-progress-line {
		width: 100%;

		.ant-progress-inner {
			background-color: #e6e6e6;
		}
	}

	.ant-progress-success-bg,
	.ant-progress-bg {
		background-color: rgba(0, 47, 187, 1);
	}
`;

export const StyledButtonTootipSelected = styled(Button)`
	font-size: 11px;
	margin-right: 10px;
	background-color: #e6eaf8;
	border: 1px solid #e6eaf8;
	color: #2f54eb;
`;

export const StyledButtonTootipUnselected = styled(Button)`
	font-size: 11px;
	margin-left: 10px;
	background-color: #ffffff;
	border: 1px solid #e6e6e6;
	color: #262626;
`;

export const StyledTooltipCol = styled(Col)`
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const StyledPerformanceText = styled.p`
	font-size: 14px;
	color: rgba(255, 0, 0, 1);
	margin-bottom: 16px;
`;

export const CenteredCol = styled(Col)`
	display: flex;
	justify-content: center;
`;

export const CustomSlider = styled(Slider)<{ $value?: number }>`
	.ant-slider-dot {
		display: none;
	}

	.ant-slider-step {
		display: none;
	}

	.ant-slider-track {
		background-color: #5474d1;
	}

	.ant-slider-handle {
		border: 2px solid #5474d1;
		background-color: #5474d1;
		opacity: 1;
		visibility: visible;
		transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
		visibility: ${({ $value }) => ($value === undefined || $value === null ? 'hidden' : 'visible')};
	}
`;

export const StyledQuestionText = styled.p`
	margin-bottom: 16px;
	margin-top: 16px;
	font-size: 15px;
`;

export const StyledReferenceText = styled.p`
	margin-bottom: 16px;
	margin-top: 16px;
	font-size: 13px;
`;
